import React from 'react';

import { Stack, IconMail, IconCloseSmall, TextField, TextFieldButton } from '@lessonnine/design-system.lib';
import { t } from 'src/viewLayer/helpers/translations';

export default ({
  clearValue,
  disabled,
  errorKey,
  isFocused,
  onChangeHandler,
  value
}) => (
  <Stack className="InputFrame" gap={16}>
    <TextField
      actionButton={
        value ?
          <TextFieldButton
            onClick={ () => clearValue() }
            icon={ <IconCloseSmall /> }
            title={ 'Clear' }
          />
        : null
      }
      autoComplete="email"
      autoFocus={ isFocused }
      additionalText={ errorKey && t(errorKey) }
      disabled={ disabled }
      fullWidth={ true }
      icon={ <IconMail /> }
      id="uat-email-input-field"
      onChange={ onChangeHandler }
      placeholder={ t('email.placeholder') }
      state={ errorKey ? 'error' : 'default' }
      type="email"
      value={ value }
    />
  </Stack>
);
